import { ListSection } from '../../../layout/styledcomponents/TooltipStyling';
import { Box } from '@mui/material';
import React from 'react';

export const TooltipCancellationContent = ({
    content,
    maxHeight,
}: {
    content: { title: string; items: string[] }[];
    maxHeight?: number;
}) => (
    <Box
        sx={{
            maxHeight,
            overflowY: 'auto',
        }}
    >
        {content.map((item) => (
            <ListSection
                key={item.title}
                title={item.title}
                items={item.items}
            />
        ))}
    </Box>
);
